<template>
  <div>
    <Nav />
    <!-- Nav는 fixed 라서 높이만큼 본문을 내린다 -->
    <div style="padding-top: var(--nav-height, 80px)">
      <ConferenceDetailPage />
    </div>
    <conferenceFooter />
  </div>
</template>

<script>
import Nav from "@/components/new/Nav.vue";
import ConferenceDetailPage from "@/pages/conferenceDetailPage.vue";
import conferenceFooter from "@/pages/new/conferenceFooter.vue";

export default {
  name: "conferenceView",
  components: { Nav, ConferenceDetailPage, conferenceFooter },
};
</script>

<style scoped></style>
